import React from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import { Link } from 'react-router-dom';
import ROUTES from '@/routes/routes-enums';
import { User } from '@repo/common-types';

interface UserInfoProps {
  user: Pick<User, 'id' | 'alias' | 'email'>;
}

const UserInfo: React.FC<UserInfoProps> = ({ user }) => {
  return (
    <Card className="mb-3">
      <CardBody>
        <CardTitle tag="h5">User Information</CardTitle>
        <div className="table-responsive">
          <table className="table-bordered mb-0 table">
            <tbody>
              <tr>
                <th scope="row">User ID</th>
                <td>
                  <Link to={`${ROUTES.USER}/${user.id}`} className="text-decoration-underline">
                    {user.id}
                  </Link>
                </td>
              </tr>
              <tr>
                <th scope="row">Alias</th>
                <td>{user.alias}</td>
              </tr>
              <tr>
                <th scope="row">Email</th>
                <td>{user.email}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </CardBody>
    </Card>
  );
};

export default UserInfo;
